import React, { useMemo } from 'react';
import { useTranslation } from '../context/TranslationContext';
import { Dropdown, DropdownOption } from './common/Dropdown';
import '../styles/LanguageSelector.css';

type Language = 'en' | 'tr' | 'de';

interface LanguageSelectorProps {
  align?: 'left' | 'right';
  className?: string;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  align = 'left',
  className = '',
}) => {
  const { currentLanguage, setLanguage, availableLanguages, t } = useTranslation();

  const languageOptions = useMemo<DropdownOption<Language>[]>(
    () => [
      {
        value: 'en',
        label: 'English',
        icon: (
          <span className="language-flag" role="img" aria-label="English">
            🇺🇸
          </span>
        ),
      },
      {
        value: 'tr',
        label: 'Türkçe',
        icon: (
          <span className="language-flag" role="img" aria-label="Türkçe">
            🇹🇷
          </span>
        ),
      },
      {
        value: 'de',
        label: 'Deutsch',
        icon: (
          <span className="language-flag" role="img" aria-label="Deutsch">
            🇩🇪
          </span>
        ),
      },
    ],
    []
  );

  const filteredOptions = useMemo(() => {
    if (!availableLanguages || availableLanguages.length === 0) return languageOptions;
    return languageOptions.filter((opt) => availableLanguages.includes(opt.value));
  }, [availableLanguages, languageOptions]);

  const handleChange = (newLang: Language) => {
    setLanguage(newLang);
  };

  return (
    <div className={`portal-language-selector ${className}`}>
      <Dropdown<Language>
        options={filteredOptions}
        value={currentLanguage}
        onChange={handleChange}
        align={align}
        className="language-dropdown"
        ariaLabel={t('common.language_selector_aria')}
      />
    </div>
  );
};

export default LanguageSelector;